const cardItems = [
  {
    title: '热血完结必刷清单',
    desc: '从少年Jump台柱到小众燃作，热血战斗类完结漫画大全，每一部都让你燃到最后一页。',
    tag: '热血',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20manga%20art%20style%20with%20warm%20orange%20and%20red%20energy%20bursts%2C%20silhouettes%20in%20battle%20pose%2C%20dramatic%20lighting%2C%20illustration%20style%2C%20no%20text%2C%20epic%20composition%2C%20warm%20vibrant%20tones&width=600&height=400&seq=card-manga-01&orientation=landscape',
    stat: '12部精选',
    statIcon: 'ri-fire-line',
  },
  {
    title: '恋爱甜漫全集补完',
    desc: '青梅竹马、办公室恋情、校园初恋……恋爱类完结漫画完整版合集，糖分超标警告。',
    tag: '恋爱',
    img: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20illustration%20in%20manga%20style%2C%20couple%20silhouettes%20under%20cherry%20blossoms%2C%20warm%20pink%20and%20peach%20tones%2C%20gentle%20sunset%20light%2C%20no%20text%2C%20dreamy%20atmosphere&width=600&height=400&seq=card-manga-02&orientation=landscape',
    stat: '18部精选',
    statIcon: 'ri-heart-line',
  },
  {
    title: '悬疑烧脑完结神作',
    desc: '反转再反转，结局惊掉下巴。悬疑推理类完结漫画大全，智商在线的你不能错过。',
    tag: '悬疑',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20noir%20style%20illustration%20with%20dramatic%20shadows%20and%20warm%20amber%20light%2C%20detective%20atmosphere%2C%20magnifying%20glass%20on%20dark%20wooden%20desk%2C%20moody%20composition%2C%20no%20text%2C%20suspenseful%20aesthetic&width=600&height=400&seq=card-manga-03&orientation=landscape',
    stat: '8部精选',
    statIcon: 'ri-search-eye-line',
  },
  {
    title: '异世界冒险完结录',
    desc: '转生、召唤、游戏世界——异世界题材完结漫画完整版，从零到通关的全记录。',
    tag: '异世界',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20adventure%20illustration%20with%20warm%20golden%20light%2C%20magical%20portal%20glowing%2C%20ancient%20ruins%20in%20distance%2C%20epic%20landscape%2C%20illustration%20style%2C%20no%20text%2C%20warm%20earthy%20tones&width=600&height=400&seq=card-manga-04&orientation=landscape',
    stat: '15部精选',
    statIcon: 'ri-earth-line',
  },
  {
    title: '日常治愈完结合集',
    desc: '温馨搞笑的日常系漫画全集，没有刀没有虐，只有让人心情变好的小故事。',
    tag: '日常',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20warm%20cafe%20scene%20in%20illustration%20style%2C%20soft%20sunlight%20through%20windows%2C%20pottered%20plants%20and%20books%2C%20comfortable%20atmosphere%2C%20cream%20and%20beige%20tones%2C%20no%20text%2C%20peaceful%20composition&width=600&height=400&seq=card-manga-05&orientation=landscape',
    stat: '10部精选',
    statIcon: 'ri-cup-line',
  },
  {
    title: '经典老漫完结重温',
    desc: '那些陪伴一代人成长的经典完结漫画全集，无论看多少遍都不会腻的传世之作。',
    tag: '经典',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20manga%20art%20style%20illustration%2C%20warm%20sepia%20and%20cream%20tones%2C%20old%20books%20stacked%20on%20wooden%20desk%2C%20nostalgic%20atmosphere%2C%20soft%20lighting%2C%20no%20text%2C%20classic%20composition&width=600&height=400&seq=card-manga-06&orientation=landscape',
    stat: '20部精选',
    statIcon: 'ri-vip-crown-line',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            六大品类完结漫画精选合集，帮你快速找到想看的漫画全集
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-3">
                  {item.desc}
                </p>
                <div className="flex items-center gap-1.5 text-xs text-accent-600">
                  <i className={`${item.statIcon} text-sm`}></i>
                  <span className="font-semibold">{item.stat}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}